function init(){
    $("table.table-card-mobile").each(function(){
        var tabela = $(this);
        var listaTh = tabela.find("thead tr th");
        tabela.find("tbody tr").each(function(){
            $(this).find("td").each(function(index){
                    if(listaTh[index].innerHTML != ""){
                        $(this).html( "<span class='visible-xs visible-sm titulo-mobile-table'>"+listaTh[index].innerHTML+": </span>" + $(this).html());
                    }
            });
            
        });
    });
}
module.exports = {
    init
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/table-card-mobile.js